import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import { Helmet } from "react-helmet";
import Loading from "../../components/common/Loading";

const BrandsDetailMobilePage = () => {
  const { name } = useParams();
  const [show, setShow] = useState();

  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);

  const [loading, setLoading] = useState();

  const url = `https://1924.ir/brands/${name}`;

  const [brand, setBrand] = useState();
  const [category, setcategory] = useState([]);
  const [vehicles, setvehicles] = useState([]);
  const [selected, setselected] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setData(data?.data[0]);
    });
    await httpReauest("GET", "/brand/mobile/" + name, {}, {}).then(
      ({ data }) => {
        setBrand(data?.data?.brand);
        setcategory(data?.data?.category);
        setvehicles(data?.data?.vehicles);
      }
    );
    setLoading(false);
  }

  if (loading) {
    return <Loading />;
  }
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"1924 -" + brand?.name}</title>
        <meta name="description" content={brand?.desc} />
        <meta name="keywords" content={""} />
        <meta name="og:description" content={brand?.desc} />
        <meta name="og:title" content={"1924 -" + brand?.name} />
        <link rel="canonical" href={url} />
      </Helmet>{" "}
      {show && <RequestTalkModal setShow={setShow} />}
      <Link to={"/brands"} className="flex gap-2 items-center text-[14px]">
        <img src="/Arrow - Left 2.png" alt="" className="w-[24px]" />
        بازگشت به برند ها
      </Link>
      <div className="w-full py-3  flex gap-3 items-center">
        <span className="w-[66px] h-[66px] rounded-full flex justify-center items-center overflow-hidden">
          <img
            className="w-full h-full object-contain"
            src={CDN_BASE_URL + brand?.logo}
            alt={brand?.name}
          />
        </span>
        <span>
          <h3 className="text-[18px] font-bold">{brand?.name}</h3>
          <span className="">
            از سال
            {new Intl.DateTimeFormat("fa-IR")
              .format(new Date(brand?.createdAt ? brand?.createdAt : null))
              ?.slice(0, 4)}{" "}
            | {vehicles?.length} خودرو
          </span>
        </span>
      </div>
      <div>
        <Link
          to={`tel:${data?.phone}`}
          className="btn-brand-mobile  w-full block text-center my-2"
        >
          {data?.phone}
        </Link>
        <button
          onClick={() => setShow(true)}
          className="border-brand-2 p-3 w-full block text-center mt-3 mb-4"
        >
          درخواست مشاوره تلفنی
        </button>
      </div>
      <div className="w-full flex gap-3 py-3 overflow-x-scroll border-b border-dashed border-[#8E9192] text-[14px]">
        {/* {category?.map((cat) => (
          <span
            onClick={() =>
              cat === selected ? setselected("") : setselected(cat)
            }
            className={`${
              selected === cat ? "bg-black text-white" : ""
            } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
          >
            {cat}
          </span>
        ))}
        <span
          onClick={() =>
            brand?.title === selected
              ? setselected("")
              : setselected(brand?.title)
          }
          className={`${
            selected === brand?.title ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {brand?.title}
        </span>  */}
      </div>
      <div>
        <img
          src={CDN_BASE_URL + brand?.cover}
          className="w-full my-6 rounded-[10px] center"
          alt=""
        />
        <h1 className="title">{brand?.title}</h1>
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: brand?.desc }}
        />
      </div>
      {/* <div className="grid grid-cols-3 gap-1 py-3">
        {selected == brand?.title ? (
          <div dangerouslySetInnerHTML={{ __html: brand?.desc }} />
        ) : (
          vehicles?.map((e) => {
            if (selected) {
              if (selected == e?.category.name) {
                return (
                  <Link
                    to={`/${e?.url?.category?.url}/${e?.url?.brand?.name}/${e?.url?.name}`}
                  >
                    <img
                      alt={e.name}
                      className="object-cover rounded-[6px] h-[29vw] w-full"
                      src={CDN_BASE_URL + e.img}
                    />
                  </Link>
                );
              }
            } else {
              return (
                <Link
                  to={`/${e?.url?.category?.url}/${e?.url?.brand?.name}/${e?.url?.name}`}
                >
                  <img
                    alt={e.name}
                    className="object-cover rounded-[6px] h-[29vw] w-full"
                    src={CDN_BASE_URL + e.img}
                  />
                </Link>
              );
            }
          })
        )}
      </div> */}
    </div>
  );
};

export default BrandsDetailMobilePage;
